import { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  Link,
  TextField,
  Typography,
} from '@mui/material';

import customAxios from '../../utils/customAxios';
import { GlobalVariables } from '../../globalVar';
import variables from '../../scss/_variables.scss';
import { getToast } from '../../utils/toastConfig';

const HEADERS = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  },
};

const ConfigProfile = () => {
  const [modules, setModules] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [coords, setCoords] = useState([0, 0]);

  const userId = localStorage.getItem('currUserLogged');

  useEffect(() => {
    getModules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (modules.Mapa) {
      const mapCoords = JSON.parse(modules.Mapa[0].value);
      setCoords(mapCoords);
    }
  }, [modules]);

  const getModules = async () => {
    setIsLoading(false);
    try {
      const endpoint = `${GlobalVariables.getURL()}user-config/${userId}`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (!response.data.data.modules) {
        setModules({});
        return;
      }
      setModules(response.data.data.modules);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({ status: 'error', title: error.response.data.message });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (configId) => {
    if (coords[0] === null || coords[1] === null) return;

    setIsLoading(true);
    try {
      const endpoint = `${GlobalVariables.getURL()}update-user-config/${configId}`;
      const stringCoords = JSON.stringify(coords);

      const response = await customAxios.patch(
        endpoint,
        { value: stringCoords },
        HEADERS
      );
      console.log('🚀 ~ response:', response);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({ status: 'error', title: error.response.data.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='full-container'>
      <Grid container flexDirection='column' sx={{ mt: 2, mb: 1 }}>
        <Typography fontSize={18} fontWeight='bold'>
          Configuración del perfil
        </Typography>
        <Typography fontSize={14} color='rgba(0,0,0,0.5)'>
          Personaliza el comportamiento de algunos módules del sistema a tu
          preferencia
        </Typography>
      </Grid>
      <Divider sx={{ borderColor: 'black' }} />
      {isLoading ? (
        <Grid
          container
          alignItems='center'
          justifyContent='center'
          width='100%'
        >
          <CircularProgress sx={{ color: variables.redDabi, mt: 10 }} />
        </Grid>
      ) : (
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {Object.keys(modules).length > 0 &&
            Object.entries(modules).map(([key, value], index) => {
              if (key === 'Mapa') {
                return (
                  <Grid id='section' item xs={12} key={key}>
                    <div id='description' style={{ marginBottom: '1rem' }}>
                      <Typography>{key === 'Mapa' ? 'Mapas' : ''}</Typography>
                      <Typography fontSize={14} color='rgba(0,0,0,0.5)'>
                        {value[index] && value[index].functionName}
                      </Typography>
                      <Box gap={2} display='flex' mt={2}>
                        <TextField
                          type='number'
                          required
                          fullWidth
                          label='Latitud'
                          placeholder='Latitud...'
                          value={coords[0]}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            if (newValue !== '') {
                              setCoords([parseFloat(newValue), coords[1]]);
                            }
                          }}
                          onBlur={(e) => {
                            if (
                              e.target.value === '' ||
                              isNaN(parseFloat(e.target.value))
                            ) {
                              setCoords([coords[0], coords[1]]);
                              getToast({
                                status: 'error',
                                title: 'Latitud no puede estar vacía.',
                              });
                            } else {
                              handleSubmit(value[index].configId);
                            }
                          }}
                        />
                        <TextField
                          type='number'
                          required
                          fullWidth
                          label='Longitud'
                          placeholder='Longitud...'
                          value={coords[1]}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            if (newValue !== '') {
                              setCoords([coords[0], parseFloat(newValue)]);
                            }
                          }}
                          onBlur={(e) => {
                            if (
                              e.target.value === '' ||
                              isNaN(parseFloat(e.target.value))
                            ) {
                              setCoords([coords[0], coords[1]]);
                              getToast({
                                status: 'error',
                                title: 'Longitud no puede estar vacía.',
                              });
                            } else {
                              handleSubmit(value[index].configId);
                            }
                          }}
                        />
                      </Box>
                    </div>
                    <Link
                      href='https://support.google.com/maps/answer/18539?hl=es-MX&co=GENIE.Platform%3DDesktop'
                      underline='always'
                      target='_blank'
                    >
                      ¿Cómo obtengo la latitud y longitud de un lugar?
                    </Link>
                    <Divider
                      sx={{ borderColor: 'rgba(0,0,0,0.5)', marginTop: '1rem' }}
                    />
                  </Grid>
                );
              } else {
                return <></>;
              }
            })}
        </Grid>
      )}
    </div>
  );
};

export default ConfigProfile;
